<template>
  <v-snackbar v-model="snackbar" :color="color" :timeout="timeout">
    {{ text }}
    <template #action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import eventBus from '@/foundations/services/eventBus';

export default {
  name: 'SnackBarV2',

  data() {
    return {
      snackbar: false,
      text: '',
      color: 'primary',
      timeout: 3000,
    };
  },

  mounted() {
    eventBus.$on('snackbarV2.open', async ({ text, color = 'primary', timeout = 3000 }) => {
      this.text = text;
      this.color = color;
      this.timeout = timeout;
      this.snackbar = true;
    });
  },
};
</script>

<style scoped></style>
